// extracted by mini-css-extract-plugin
module.exports = {"container":"detail_container__14FQ_","content":"detail_content__hc04V","header":"detail_header__2R4a8"};